:host {
  display: block;
  width: var(--image-width, fit-content);
  height: var(--image-height, fit-content);
}

img {
  float: left;
  width: var(--image-width, fit-content);
  height: var(--image-height, fit-content);
}
